import { render, staticRenderFns } from "./editPrice.vue?vue&type=template&id=54164277&scoped=true&"
import script from "./editPrice.vue?vue&type=script&lang=js&"
export * from "./editPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54164277",
  null
  
)

export default component.exports